import { render } from "./ErrorsApi.vue?vue&type=template&id=cb31408a"
import script from "./ErrorsApi.vue?vue&type=script&lang=js"
export * from "./ErrorsApi.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/Baguer/Develop/Quac/pagosquac-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__